import { render } from "./Column202509_2.vue?vue&type=template&id=7fb36875&scoped=true"
import script from "./Column202509_2.vue?vue&type=script&lang=js"
export * from "./Column202509_2.vue?vue&type=script&lang=js"

import "./Column202509_2.vue?vue&type=style&index=0&id=7fb36875&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7fb36875"

export default script